import React, { useState } from "react";
import { Button, Icon } from "../../components/Component";
// import Logo from "../../images/logo.png";
// import LogoDark from "../../images/logo-dark.png";
import Logo from "../../images/logo12.png";
import LogoDark from "../../images/logo12.png";
import { Form, FormGroup, Spinner, Alert } from "reactstrap";
import PageContainer from "../../layout/page-container/PageContainer";
import Head from "../../layout/head/Head";
import AuthFooter from "./AuthFooter";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";

import {authService} from "../../_services/auth";
import {toaster} from "../../_helpers/toaster";
import { useUserContext } from "../../MyUserContext";
import "./login.css";

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [passState, setPassState] = useState(false);
  const [errorVal, setError] = useState("");
  const {setUser} = useUserContext()


  const onFormSubmit = (formData) => {
    setLoading(true);

    authService.login(formData).then(
      result =>{
        // console.log(result);
        setUser(result);
        window.history.pushState({} , "auth-login", "/"  );

        setTimeout(()=>{
          window.location.reload();
        },300);        
       
      },
      err =>{
        console.log(err);
        toaster.error(err);
        setLoading(false);
      }
    )
  };

  const { errors, register, handleSubmit } = useForm();

  return (
    <React.Fragment>
      <Head title="Login" />
      <PageContainer>
        <main className="login-page">
          <section className="login-showcase" aria-label="About MYUAE">
            <div className="login-showcase__glow login-showcase__glow--one" />
            <div className="login-showcase__glow login-showcase__glow--two" />
            <Link to={"/"} className="login-brand login-brand--light" aria-label="MYUAE home">
              <img src={LogoDark} alt="MYUAE" />
            </Link>

            <div className="login-showcase__content">
              <span className="login-eyebrow"><i /> Your business, simplified</span>
              <h1>Everything you need to build in the UAE.</h1>
              <p>
                Manage your company setup, applications, and documents from one secure, beautifully simple workspace.
              </p>

              <div className="login-benefits">
                <div><span><Icon name="check" /></span><p><strong>One clear workspace</strong>Keep every step organised and on track.</p></div>
                <div><span><Icon name="check" /></span><p><strong>Built for peace of mind</strong>Your business data stays protected.</p></div>
              </div>
            </div>

            <div className="login-showcase__footer">
              <span className="login-status"><i /> All systems operational</span>
              <span>Trusted support, whenever you need it</span>
            </div>
          </section>

          <section className="login-panel">
            <div className="login-panel__inner">
              <Link to={"/"} className="login-brand login-brand--mobile" aria-label="MYUAE home">
                <img src={Logo} alt="MYUAE" />
              </Link>

              <div className="login-heading">
                <span className="login-heading__icon"><Icon name="user" /></span>
                <div>
                  <h2>Welcome back</h2>
                  <p>Sign in to continue to your MYUAE account.</p>
                </div>
              </div>

            {errorVal && (
              <div className="mb-3 login-alert">
                <Alert color="danger" className="alert-icon">
                  {" "}
                  <Icon name="alert-circle" /> Unable to login with credentials{" "}
                </Alert>
              </div>
            )}
            <Form className="is-alter login-form" onSubmit={handleSubmit(onFormSubmit)}>
              <FormGroup className="login-field">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="default-01">
                    Email address
                  </label>
                </div>
                <div className="form-control-wrap">
                  <input
                    type="text"
                    id="default-01"
                    name="email"
                    ref={register({ required: "This field is required" })}
                    defaultValue=""
                    placeholder="you@company.com"
                    className="form-control-lg form-control"
                  />
                  {errors.email && <span className="invalid">{errors.email.message}</span>}
                </div>
              </FormGroup>
              <FormGroup className="login-field">
                <div className="form-label-group">
                  <label className="form-label" htmlFor="password">
                    Password
                  </label>
                  <Link className="login-forgot" to={`/auth-forgot`}>
                    Forgot password?
                  </Link>
                </div>
                <div className="form-control-wrap">
                  <a
                    href="#password"
                    onClick={(ev) => {
                      ev.preventDefault();
                      setPassState(!passState);
                    }}
                    className={`form-icon lg form-icon-right passcode-switch login-password-toggle ${passState ? "is-hidden" : "is-shown"}`}
                    aria-label={passState ? "Hide password" : "Show password"}
                  >
                    <Icon name="eye" className="passcode-icon icon-show"></Icon>

                    <Icon name="eye-off" className="passcode-icon icon-hide"></Icon>
                  </a>
                  <input
                    type={passState ? "text" : "password"}
                    id="password"
                    name="password"
                    defaultValue=""
                    ref={register({ required: "This field is required" })}
                    placeholder="Enter your password"
                    className={`form-control-lg form-control ${passState ? "is-hidden" : "is-shown"}`}
                  />
                  {errors.password && <span className="invalid">{errors.password.message}</span>}
                </div>
              </FormGroup>
              <FormGroup className="login-submit-wrap">
                <Button size="lg" className="btn-block login-submit" type="submit" color="primary" disabled={loading}>
                  {loading ? <Spinner size="sm" color="light" /> : <span>Sign in <Icon name="arrow-right" /></span>}
                </Button>
              </FormGroup>
            </Form>
            <div className="login-register">
              New to MYUAE? <Link to={`/auth-register`}>Create an account</Link>
            </div>

              <div className="login-security"><Icon name="shield-check" /> Secure, encrypted sign in</div>
            </div>
          </section>
        </main>
        <div className="login-footer"><AuthFooter /></div>
      </PageContainer>
    </React.Fragment>
  );
};
export default Login;
